module.exports = __webpack_public_path__ + "img/08@2x.b6c48d4b.png";